import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { Link } from "react-router-dom";
import { formatMonthYear } from "../../../helpers/general";

function TabbleBodyRowContent({
  invoice,
}: {
  invoice: MultiPlaceAdminInvoice;
}) {
  return (
    <CTableRow
      style={{
        width: "100%",
        position: "relative",
      }}
    >
      <CTableDataCell className="p-3 text-capitalize text-sm">
        {invoice.createdFor.fullName}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-capitalize text-sm">
        {formatMonthYear(invoice.month, invoice.year)}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-capitalize text-sm">
        {invoice.total} DH
      </CTableDataCell>
      <CTableDataCell className="p-3 text-capitalize text-sm">
        {invoice.partnerCommission} DH
      </CTableDataCell>
      <CTableDataCell className="p-3 text-capitalize text-sm">
        {invoice.placeTotal} DH
      </CTableDataCell>
      <CTableDataCell className="p-3 text-capitalize text-sm">
        <Link
          to={`/invoices/details/${invoice.id}`}
          type="button"
          className="btn rounded-pill border py-1 px-3 text-sm"
        >
          Voir la facture
        </Link>
      </CTableDataCell>
    </CTableRow>
  );
}

export default function InvoicesTable({
  invoices,
}: {
  invoices: MultiPlaceAdminInvoice[];
}) {
  return (
    <div className="mt-3">
      <CTable responsive>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col">Partenaire</CTableHeaderCell>
            <CTableHeaderCell scope="col">Date de facturation</CTableHeaderCell>
            <CTableHeaderCell scope="col">Revenu</CTableHeaderCell>
            <CTableHeaderCell scope="col">
              Commission hôtelière
            </CTableHeaderCell>
            <CTableHeaderCell scope="col">Vous</CTableHeaderCell>
            <CTableHeaderCell scope="col"></CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {invoices?.map((invoice) => (
            <TabbleBodyRowContent invoice={invoice} key={invoice?.id} />
          ))}
        </CTableBody>
      </CTable>
    </div>
  );
}
